// extracted by mini-css-extract-plugin
module.exports = {"page":"UserManagement_page__27ti0","container":"UserManagement_container__2PVDJ","header":"UserManagement_header__104Jr","loadMoreWrapper":"UserManagement_loadMoreWrapper__2uCUk"};